import React, { useState, useEffect } from "react"
import { useMemo } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ToastContainer, toast } from "react-toastify"
import {
  getLOBStart,
  DeleteLOBStart,
  UpdateLOBReset,
  DeleteLOBReset,
  CreateLOBReset,
} from "store/SuperAdmin/Lob-SubLob-company-income/action"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Button,
  Spinner,
  Badge,
} from "reactstrap"
import DeleteModal from "components/Common/DeleteModal"
import { Link, useParams, useLocation } from "react-router-dom"
import TableContainer from "components/Common/TableContainer"
import { useDispatch, useSelector } from "react-redux"

// CREATE LOB :
import CreateLOB from "./CreateLob"
import UpdateLob from "./UpdateLob"
const Home = () => {
  const [dmodal, setdModal] = useState(false)

  const [updateData, setUpdateData] = useState()

  const [OpenModal, setOpenModal] = useState(false)
  const [UpdateModal, setUpdatModal] = useState(false)
  const [l_id, setLid] = useState()

  const CreateFunc = () => {
    setOpenModal(!OpenModal)
  }

  const OpenUpdateModel = () => {
    setUpdatModal(!UpdateModal)
  }
  const { loading, LOB, updated, Iscreated, deleted } = useSelector(
    state => state.SuperAdminLob
  )
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getLOBStart())
  }, [])

  useEffect(() => {
    if (Iscreated) {
      toast.success("LOB IsCreated successfully")
      CreateFunc()
      dispatch(CreateLOBReset())
      dispatch(getLOBStart())
    }
  }, [Iscreated])

  useEffect(() => {
    if (updated) {
      toast.success("LOB updated successfully")
      OpenUpdateModel()
      dispatch(UpdateLOBReset())
      dispatch(getLOBStart())
    }
  }, [updated])

  useEffect(() => {
    if (deleted) {
      toast.success("LOB deleted successfully")
      dispatch(DeleteLOBReset())
      setdModal(false)
      dispatch(getLOBStart())
    }
  }, [deleted])

  const handleDelete = () => {
    dispatch(DeleteLOBStart({ id: l_id }))
    dispatch(DeleteLOBReset())
  }

  const handleUpdate = id => {
    const filterData = LOB.data.filter(item => item.id === id)
    setUpdateData(filterData)
    setUpdatModal(true)
  }

  const columns = useMemo(() => [
    {
      Header: "Sr No",
      Cell: cellProps => {
        return <>{cellProps.row.original.id}</>
      },
    },
    {
      Header: "Insurnace Type",
      accessor: "type",
      Cell: cellProps => {
        return <>{cellProps.row.original.type}</>
      },
    },
    {
      Header: "LOB",
      accessor: "LOB",
      Cell: cellProps => {
        return <>{cellProps.row.original.LOB}</>
      },
    },
    {
      Header: "Color Code",
      accessor: "color_code",
      Cell: cellProps => {
        return <>{cellProps.row.original.color_code}</>
      },
    },
    {
      Header: "Color",
      Cell: cellProps => {
        return (
          <>
            {" "}
            <button
              style={{
                backgroundColor: `${cellProps.row.original.color_code}`,
                width: "40px",
                height: "30px",
                border: "none",
              }}
            ></button>
          </>
        )
      },
    },
    {
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      Cell: cellProps => {
        const currentDate = new Date()
        const endDate = new Date(cellProps.row.original.end_date)
        return (
          <>
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li
                onClick={() => {
                  handleUpdate(cellProps.row.original.id)
                }}
                className="btn btn-sm btn-soft-info"
                id={`edittooltip-${cellProps.row.original.id}`}
              >
                <i className="mdi mdi-pencil-outline" />
                <UncontrolledTooltip
                  placement="top"
                  target={`edittooltip-${cellProps.row.original.id}`}
                >
                  Edit
                </UncontrolledTooltip>
              </li>

              {/* <li>
                <Link
                  to={`/update-policy/${id}/${cellProps.row.original.id}`}
                  onClick={() => {
                    setLid(cellProps.row.original.id)
                    setdModal(true)
                  }}
                  className="btn btn-sm btn-soft-info"
                  id={`deletetooltip-${cellProps.row.original.id}`}
                >
                  <i className="mdi mdi-delete" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deletetooltip-${cellProps.row.original.id}`}
                  >
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </li> */}
            </ul>
          </>
        )
      },
    },
  ])

  return (
    <React.Fragment>
      <DeleteModal
        show={dmodal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setdModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <h3 className="mb-0 card-title flex-grow-1">LOB</h3>

                    <Button onClick={CreateFunc} className="btn btn-dark">
                      {" "}
                      Create LOB
                    </Button>
                  </div>
                </CardBody>

                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={LOB?.data || []}
                    isGlobalFilter={true}
                    isAddOptions={false}
                    loading={loading}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={10}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={OpenModal} toggle={CreateFunc} size="md">
            <ModalHeader toggle={CreateFunc} tag="h4">
              <h3>Add LOB</h3>
            </ModalHeader>
            <ModalBody>
              <CreateLOB />
            </ModalBody>
          </Modal>

          {/* UPDATE MODAL */}
          <Modal isOpen={UpdateModal} toggle={OpenUpdateModel} size="md">
            <ModalHeader toggle={OpenUpdateModel} tag="h4">
              <h3>Update LOB</h3>
            </ModalHeader>
            <ModalBody>
              <UpdateLob updateData={updateData} />
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default Home
